import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';

// components
import { CircleAvatar } from "../../Elements/Avatars";
import { ButtonSimple } from "../../Elements/Buttons";

// actions
import {
    toggleMobileSideMenu
} from '../../../Actions/ui'

import {
    toggleMapTop,
    toggleMode,
    resetFiltersType,
    openVideoModal
} from '../../../Actions/main';
import { openLoginModal, signOut } from '../../../Actions/users'

import { BAND, MUSICIAN, SERVICE, MUGICS_LIST } from "../../../consts";

//styles
import './MobileSideMenu.css';

// icons
import closeSVG from "../../inlineSVGs/crossSVG";
import liveMusicNavSVG from "../../inlineSVGs/liveMusicNavSVG";
import servicesNavSVG from "../../inlineSVGs/servicesNavSVG";
import bandFinderNavSVG from "../../inlineSVGs/bandFinderNavSVG";
import musicianFinderNavSVG from "../../inlineSVGs/musicianFinderNavSVG";
import logoutDoorSVG from "../../inlineSVGs/logoutDoorSVG";
import {ToggleMap} from "../../Elements/Toggles";
import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock";
import { SpreadIcons } from "../../Elements/Decorations";
import smallStarSVG from "../../inlineSVGs/smallStarSVG";
import {Link} from "react-router";
import { getUsernameFromToken } from "../../../utils";
import {AnalyticsService} from "../../../Services";
import videoBtnMobileSVG from "../../inlineSVGs/videoBtnMobileSVG";

class MobileSideMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            scrollY: 0
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isMobileSideMenuOpen && !prevProps.isMobileSideMenuOpen) {
            setTimeout(() => {
                disableBodyScroll(document.body);
            }, 200);

            // TODO: position in scroll pos
            this.setState({ scrollY: window.scrollY})
        } else if (!this.props.isMobileSideMenuOpen && prevProps.isMobileSideMenuOpen) {
            // window.document.body.style.overflow = 'initial';
            clearAllBodyScrollLocks();
        }
    }

    getFormattedUsername(token) {
        return getUsernameFromToken(token);
        // return username.length > 5 ? username.slice(0, 5) + '...' : username;
    }

    getStarIcons() {
        return [
            {top: 15, right: 5, opacity: 0.5, width: '20'},
            {top: 8, right: 40, opacity: 0.5, width: '12'},
            {top: 40, right: 70, opacity: 0.5, width: '8'},
            {top: 3, right: 90, opacity: 0.5, width: '10'},
            {top: 10, right: 100, opacity: 0.5, width: '4'},
            {top: 2, left: 10, opacity: 0.5, width: '10'},
            {top: 30, right: 120, opacity: 0.5, width: '3'},
            {top: 30, left: 5, opacity: 0.5, width: '6'},
            {bottom: 10, left: 5, opacity: 0.5, width: '11'},
            {bottom: 2, left: 15, opacity: 0.5, width: '3'},
            {top: 0, right: 123, opacity: 0.5, width: '18'},
        ]
    }

    handleTypeSelect(type) {
        this.props.resetFiltersType(type);

        window.location = `/#${type}`;
        AnalyticsService.sendEvent(AnalyticsService.events.TOP_FILTER, type, null, { type });
    }

    handleMapToggle() {
        this.props.resetFiltersType(this.props.filters.type);
        this.props.toggleMode();
    }

    renderTypeButton(type, currentType) {
        let text = 'הופעות חיות'// 'Live shows';
        let size = '30px';
        let icon = liveMusicNavSVG;
        if (type === SERVICE) {
            text = 'שירותי מוזיקה'// 'Music services';
            icon = servicesNavSVG;
            size = '25px';
        }
        if (type === BAND) {
            text = 'מצא להקה'// 'Band maker-find bands';
            icon = bandFinderNavSVG
            size = '40px';
        }
        if (type === MUSICIAN) {
            text = 'מצא מוזיקאי ללהקה שלך'// 'Band maker-find musician';
            icon = musicianFinderNavSVG
        }

        return (
            <div
                key={`side-menu-cats-${type}`}
                className={`row-btn mode-btn rtl ${type} ${type === currentType ? 'active' : ''}`}
                onClick={() => this.handleTypeSelect(type)}
            >
                <SVGInline svg={icon} width={size} className="type-icon" />
                <label className="row-text">{text}</label>
                {type === currentType ?
                    <SpreadIcons
                        isLoopMove
                        iconSVG={smallStarSVG}
                        component={'i'}
                        icons={this.getStarIcons()}
                    />
                    : null}
            </div>
        )
    }

    renderCenterSection() {
        if (!this.props.filters) return;

        return (
            <div className="sections center">
                {MUGICS_LIST.map(mugicsType => this.renderTypeButton(mugicsType, this.props.filters.type))}
            </div>
        )
    }

    // Login/Signup
    renderNonLoggedHeader() {
        return (
            <div className="sections top">
                <CircleAvatar />
                <ButtonSimple
                    onPress={() => this.props.openLoginModal()}
                    label="התחבר/הרשם"
                    customClass="side-menu-btn"
                />
            </div>
        )
    }

    renderLoggedHeader() {
        const { userName, userEmail } = getUsernameFromToken(this.props.token);

        return (
            <div className="sections top">
                <Link
                    onClick={() => {
                        setTimeout(() => {
                            this.props.toggleMobileSideMenu();
                        }, 500)
                    }}
                    className="link-wrapper" to="/user-panel"
                    onlyActiveOnIndex={false}
                >
                    <CircleAvatar />
                    <div className="user-name">{userName}</div>
                    <div className="user-email">{userEmail}</div>
                </Link>
            </div>
        )
    }

    // Logout
    render() {

        return (
            <div
                className={`mobile-side-menu rtl ${this.props.isMobileSideMenuOpen ? 'open' : 'closed'}`}
                style={{top: `${this.state.scrollY || 0}px`}}
            >
                <div className="blur-bg"></div>
                <div className="content-wrapper">
                    <div className="close-wrapper" onClick={() => this.props.toggleMobileSideMenu()}>
                        <SVGInline svg={closeSVG} width="25px" color="white" className="close" />
                    </div>
                    {this.props.isLoggedIn ? this.renderLoggedHeader() : this.renderNonLoggedHeader()}

                    <div className="divider"></div>
                    {this.renderCenterSection()}
                    <ToggleMap
                        isMapTop={this.props.mode === 'map'}
                        onToggle={() => this.handleMapToggle()}
                        customClass="row-btn rtl side-menu-map-toggle"
                    />
                    <div className="filter-btn-wrapper" onClick={() => this.props.openVideoModal()}>
                        <span className="video-text">וידאו</span>
                        <SVGInline svg={videoBtnMobileSVG} width="30px" className="video-icon" />
                    </div>
                    <div className="divider"></div>

                    <div className="sections bottom">
                        {this.props.isLoggedIn ?
                            <div className="row-btn rtl signout-wrapper" onClick={() => this.props.signOut()}>
                                <SVGInline svg={logoutDoorSVG} width="25px" color="white" className="signout" />
                                <label>התנתק</label>
                            </div>
                        : null}
                    </div>
                </div>
            </div>
        )
    }
}

MobileSideMenu.propTypes = {
    // state props
    isMobileSideMenuOpen: PropTypes.bool,
    datatypes: PropTypes.object,
    isMapTop: PropTypes.bool,
    mode: PropTypes.oneOf(['list', 'map', 'gallery']),
    filters: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    token: PropTypes.string,

    // state actions
    toggleMobileSideMenu: PropTypes.func,
    toggleMapTop: PropTypes.func,
    toggleMode: PropTypes.func,
    resetFiltersType: PropTypes.func,
    openLoginModal: PropTypes.func,
    signOut: PropTypes.func,
    openVideoModal: PropTypes.func
};

const mapStateToProps = state => ({
    isMobileSideMenuOpen: state.ui.isMobileSideMenuOpen,
    datatypes: state.main.datatypes,
    isMapTop: state.main.isMapTop,
    mode: state.main.mode,
    filters: state.main.filters,
    isLoggedIn: state.users.isLoggedIn,
    token: state.users.token,
})

export default connect(mapStateToProps, {
    toggleMobileSideMenu,
    toggleMapTop,
    toggleMode,
    resetFiltersType,
    openLoginModal,
    signOut,
    openVideoModal
})(MobileSideMenu)



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/MobileSideMenu/MobileSideMenu.js